module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "svgMatorEditorApp"
    }
  }, [_c('b-modal', {
    ref: "modal-svg-mator",
    attrs: {
      "size": "xl",
      "title": "Svg Mator",
      "scrollable": "",
      "id": "modal-svg-mator",
      "hide-footer": ""
    },
    model: {
      value: (_vm.changed),
      callback: function($$v) {
        _vm.changed = $$v
      },
      expression: "changed"
    }
  }, [_c('div', {
    staticClass: "w-100",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('b-button', {
    staticClass: "float-left",
    attrs: {
      "id": "svg-btn-back",
      "size": "sm"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  }), _vm._v(" Retour\n      ")])], 1), _vm._v(" "), _c('iframe', {
    staticClass: "w-100",
    attrs: {
      "id": "svg-iframe",
      "src": _vm.url
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ab1d4f40","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modal/EditorSvgMatorComponent.vue
// module id = 847
// module chunks = 1 3